<template>
  <div style="display: inline;">
    <div id="popcorn" aria-describedby="tooltip"
      @mouseenter="handleHoverTooltipShow"
      @mouseleave="handleHoverTooltipHide"
      @click="handleClickTooltipChange"
      style="padding:0;margin:0;"><slot/></div>
    <div id="tooltip" role="tooltip" v-show="tooltipVisible !== undefined ? tooltipVisible : true">
      <div>{{content}}</div>
      <div id="arrow" data-popper-arrow></div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'
import { createPopper } from '@popperjs/core';

export default {
  props: {
    // tooltip的内容
    content: {
      required: false,
      default: '',
      type: String
    },
    // tooltip的触发方式 hover click
    trigger: {
      required: false,
      default: 'hover',
      type: String
    },
    // 可以用来手动控制tooltip的出现或者消失
    visible: {
      required: false,
      default: undefined,
      type: Boolean as PropType<boolean | undefined>
    },
    // tooltip出现的位置
    placement: {
      required: false,
      default: 'bottom',
      type: String
    },
    // 可以设置tooltip的背景颜色
    background: {
      required: false,
      default: '',
      type: String
    },
  },
  watch: {
    // 对外界传入的visible进行监听，选用了vue2的写法，因为外界传入的visible可能不是一个ref只是一个简单的boolean值
    visible(newval: boolean) {
      // this.$emit 会报错 说$emit在类型里面不存在，所以用这样的方式，但实际上是存在的，将来可能需要改进下，知道的朋友说一下
      const that: any = this
      that?.$emit('change', newval)
    }
  },
  setup(props) {
    let tooltipVisible = ref(false)
    if (props.visible !== undefined) {
      tooltipVisible = ref(true)
    }

    const showTooltip = () => {
      const popcorn = document.querySelector('#popcorn');
      const tooltip = document.querySelector('#tooltip');

      createPopper(popcorn, tooltip, {
        placement: props.placement ? props.placement : 'bottom'
      });
    }

    const handleHoverTooltipShow = () => {
      if (props.trigger === 'hover' && props.visible === undefined) {        
        tooltipVisible.value = true
        showTooltip()
      }
    }

    const handleHoverTooltipHide = () => {
      if (props.trigger === 'hover' && props.visible === undefined) {        
        tooltipVisible.value = false
      }
    }

    const handleClickTooltipChange = () => {
      if (props.trigger === 'click' && props.visible === undefined) {        
        tooltipVisible.value = !tooltipVisible.value
      }
    }

    return {
      tooltipVisible,
      handleHoverTooltipShow,
      handleHoverTooltipHide,
      handleClickTooltipChange
    }
  }
}
</script>

<style scoped>
#popcorn {
  display: inline-block;
  width: auto;
  height: auto;
}

#tooltip {
  display: inline-block;
  background: #30263d;
  color: #fff;
  padding: 5px 10px;
  font-size: 13px;
  border-radius: 4px;
}

#arrow,
#arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

#arrow {
  visibility: hidden;
}

#arrow::before {
  visibility: visible;
  content: '';
  transform: rotate(45deg);
}

#tooltip[data-popper-placement^='top'] > #arrow {
  bottom: -4px;
}

#tooltip[data-popper-placement^='bottom'] > #arrow {
  top: -4px;
}

#tooltip[data-popper-placement^='left'] > #arrow {
  right: -4px;
}

#tooltip[data-popper-placement^='right'] > #arrow {
  left: -4px;
}

</style>